import { downloadFile } from '..'

export const downloadInstitutionDocument = (user, document) => {
  return downloadFile(`/institution/document/download/${document.id}`, document.originalName, user)
}
